import { PageShell } from "@/components/layout/PageShell";
import { HeroSection } from "@/components/home/HeroSection";
import { DisclaimerCard } from "@/components/home/DisclaimerCard";
import { FrameworkSection } from "@/components/home/FrameworkSection";
import { ExclusionsSection } from "@/components/home/ExclusionsSection";
import { BoundaryLinkSection } from "@/components/home/BoundaryLinkSection";
import { FinalCallToAction } from "@/components/home/FinalCallToAction";

export default function HomePage() {
  return (
    <PageShell>
      <HeroSection />
      <DisclaimerCard />
      <FrameworkSection />
      <ExclusionsSection />
      <BoundaryLinkSection />
      <FinalCallToAction />
    </PageShell>
  );
}
